import React, { useState, useEffect } from "react";
// import '../../../styles/storeList.scss'
// import styles from '../../../styles/storeList.module.scss'\
// import '../../../styles/storeList.scss'
// import './styles/storeList.scss'
import { useSelector, useDispatch } from "react-redux";
import "./Adds.scss"
// owl carasoul work end
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import { Button } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import noImg from "../../../assets/images/no-image.svg";
import Chip from "@mui/material/Chip";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { RootState } from "../../store/reducers";
import { convertTo12HourFormat } from "../../utils/genral-functions";
import nestclock from "../../assets/images/nestclock.svg"
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../store";


const Adds = (props:any) => {
  const {data} = props
  const state = useSelector((state: RootState) => state.appReducer);
  const dispatch = useDispatch();
  const {setRedirectCheckout} = bindActionCreators(actionCreators, dispatch)
  const {bookingForm, redirectCheckout } = state;
  const {bookingTime, NoGuest, bookingDate  } = bookingForm || {}
  const navigate = useNavigate();
  const { search } = useLocation();
  const searchParams: any = new URLSearchParams(search);
  const [bId, ] = useState(searchParams.get("bId"));
  const { slug } = useParams();
  const [isLoading, setIsLoading] = useState(false)
  const [appState, setappState] = useState({ langValue: "en" })
  const [category, setcategory] = useState({ branch_name: { en: "10:00 - 13:00" }, tag: [], storeInfo: { logo: null, name: "Food & Drink Event" } })

  useEffect(() => {
if(!redirectCheckout && (bookingForm == undefined || bookingForm == null )){
  navigate(`/${slug}/step-1?bId=${bId}`)
}
}, [bookingForm])
useEffect(() => {
  setRedirectCheckout(false)
}, [])


  return (
    <div
      // id={styles?.wrapperStoreList}
      
    >
      {isLoading ? (
        <React.Fragment>
          <div

            className="kanwar row m-0 mb-4 mt-3 d-flex flex-row"
          >

            <div className="col-6  ">
              <Skeleton height={50} />
            </div>
            <div className="col-10 ">
              <Skeleton height={50} />
            </div>
            <div className="col-3 ">
              <Skeleton height={50} />
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div
          id="AddsInfo"
          className={`px-2  ${appState?.langValue === "ar"
            ? `directionRt classForArabicReOrderMain`
            : ""
            } ${appState?.langValue == "ar" ? "arabicFamilyParent" : " "}`}
        >
    <Navbar showBackBtn={false}/>

          <div
            className={`row mb-3   ${appState?.langValue === "ar" ? "px-3" : "px-3"
              } `}
          >
            <div
              className={`owl_item black col-12 px-0`}

            >
              <a
                className="cursor-pointer"
          
              >
                {" "}
                <span
                  className="card-item"
            
                >
                  <section id={`Products`}>
                    <div
                      id={`category_`}
                      // id={`category_${category.name.split(" ").join("")}`}
                      className="w-100"
                    >
                      <div className={`inner_prod`} >
                        <span>
                          <div
                            // className={`${styles?.prdCard} d-flex align-items-end  w-100`}
                            className="prdCard px-3 d-flex flex-column justify-content-end"

                          style={{
                            background: `linear-gradient(90deg, rgba(0, 0, 0, 0.67) 0%, rgba(0, 0, 0, 0.19) 100%), 
                                        url(${data?.content != null
                                            ? `${data?.content }`
                                            : `./Rectangle_16965.png`
                                          }) center center / cover no-repeat`,
                          }}

                          >

                            {/* <Avatar
                  variant="square"
                  className={`${
                    appState?.langValue === "ar"
                      ? styles?.storesLogoArabic
                      : styles?.storesLogo
                  } `}
                  src={
                    category?.storeInfo?.logo
                      ? `${category?.storeInfo?.logo}`
                      : `${noImg}`
                  }
                ></Avatar> */}
                            <div
                              className={`my-3  d-flex justify-content-between  ${appState?.langValue === "ar"
                                ? `storeNameArabic`
                                : `storeName`
                                } `}
                            >
                          
                              <span 
                               className={`d-flex align-items-center ${
                                state.langValue === "ar" ? `direction-ltrt` : ""
                              }`}>
                               
                                <h1
                                  className={`reOrderheading primary-text familysora700   textOver  px-2 m-0  ${appState?.langValue === "ar"
                                    ? "text-right"
                                    : "text-left"
                                    }`}
                                >
                                  {data?.name}

                                </h1>
                              </span>


                            </div>
                            {/* <hr/> */}
                            

                          </div>

                        </span>
                      </div>
                    </div>
                  </section>
                </span>
              </a>
            </div>
          </div>

        </div>
      )}
    </div>
  );
};

export default Adds;
